module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor18.7ee5f135.png";